import { render, staticRenderFns } from "./v-form.vue?vue&type=template&id=3b4a7c4b&"
import script from "./v-form.vue?vue&type=script&lang=js&"
export * from "./v-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/X4KPpxnC/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4a7c4b')) {
      api.createRecord('3b4a7c4b', component.options)
    } else {
      api.reload('3b4a7c4b', component.options)
    }
    module.hot.accept("./v-form.vue?vue&type=template&id=3b4a7c4b&", function () {
      api.rerender('3b4a7c4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/v-form.vue"
export default component.exports